module.exports = __webpack_public_path__ + "apple_store_download.77d1a00.png";